/** Options for detail GET endpoints that support optional audit metadata. */
export type DetailGetByIdOptions = {
    /** When false, audit display fields are omitted. Default true. */
    includeAudit?: boolean;
};

export function appendIncludeAuditQuery(baseUrl: string, options?: DetailGetByIdOptions): string {
    if (options?.includeAudit !== false) {
        return baseUrl;
    }
    const separator = baseUrl.includes("?") ? "&" : "?";
    return `${baseUrl}${separator}includeAudit=false`;
}
